import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import Environment from "./Environment";
import type { UserProfile } from "~/models/UserProfile";

interface LoginCredentials {
    username: string;
    password: string;
}

interface LoginResponse {
    "token": string,
    "id": string,
    "username": string,
    "user_profile": UserProfile,
}


class UserProfileAPI {
    static userEndPoint = `${Environment.apiUrl}/users`;
    static userProfileEndPoint = `${Environment.apiUrl}/user-profiles`;

    static login = async (loginCredentials: LoginCredentials): Promise<{ data: LoginResponse }> => {
        const response = await axios.post(`${Environment.apiUrl}/login/`, loginCredentials);
        return response;
    };

    static createUser = async (createUserData: any): Promise<{ data: UserProfile }> => {
        const response = await axios.post(`${UserProfileAPI.userEndPoint}/`, createUserData);
        return response;
    };

    static patch = async (data: Partial<UserProfile>, id: number) => {
        const response = await axios.patch(`${UserProfileAPI.userProfileEndPoint}/${id}/`, data);
        return response;
    };

    static authenticateRequests = () => {

        const jwtToken = localStorage.getItem('atilaToken');

        if(!this.isLoggedIn(jwtToken)) {
            localStorage.removeItem('atilaToken');
            localStorage.removeItem('atilaUser');
            delete axios.defaults.headers.common['Authorization'];
            return false;
        }
        if (jwtToken) {
            axios.defaults.headers.common['Authorization'] = `JWT ${jwtToken}`;
        }
    }

    /**
     * Checks if the user is logged in by validating the JWT token.
     * If the token is invalid or expired, it removes the Authorization header.
     * @param jwtToken - The JWT token to validate.
     * @returns {boolean} - Returns true if the user is logged in, false otherwise.
     */
    static isLoggedIn(jwtToken: string | null): boolean {
        if (!jwtToken) {
            console.log('JWT not found');
            return false;
        }

        try {
            const decoded = jwtDecode(jwtToken);
            const currentTime = Date.now();

            if (decoded.exp && decoded.exp * 1000 <= currentTime) {
                console.log('JWT expired');
                return false;
            }

            return true;
        } catch (error) {
            console.log('Invalid JWT format');
            return false;
        }
    }

}

export default UserProfileAPI; 